import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getReturnById } from "../../api/apiReturns";

export const useGetReturnById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["return", id, i18next.language],
        queryFn: () => getReturnById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        returnRequest: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
